import Joi from 'joi-browser'
import Moment from 'moment'
import { scroller } from 'react-scroll'

const createValidador = () => {
  const fechaActual = Moment().format('YYYY-MM-DD')
  let esquemaMap
  let esquema

  const cargarEsquema = (map) => {
    esquemaMap = map
    esquema = Joi.object(esquemaMap)
  }

  const foco = () => {
    scroller.scrollTo('error', {
      duration: 500,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -200
    })
  }

  // valida todo el form desde el inicio
  const validarForm = (map, data) => {
    cargarEsquema(map)

    const errores = {}
    const { error } = esquema.validate(data, { abortEarly: true })
    if (!error) {
      return null
    }

    for (const item of error.details) {
      errores[item.path[0]] = item.message
    }
    return errores
  }

  // valida sólo la propiedad deseada
  const validarDato = (map, data, name) => {
    // eslint-disable-next-line no-prototype-builtins
    if (map.hasOwnProperty(name)) {
      const errores = {}

      cargarEsquema({ [name]: map[name] })
      const { error } = esquema.validate(data)
      if (!error) {
        return null
      }
      if (name === error.details[0].context.key) {
        errores[name] = error.details[0].message.props.children
      } else {
        return null
      }
      return errores
    } else {
      return null
    }
  }

  const mensaje = (errors, msj = '') => {
    errors.forEach((e) => {
      const tipo = e.type
      const campo = errors[0].context.label
      const limit = e.context.limit
      let msjRtn = ''

      switch (tipo) {
        case 'any.empty':
        case 'string.trim':
        case 'string.min':
          msjRtn = Msj(tipo, msj, `El campo ${campo} debe completarse`)
          break
        case 'string.max':
          msjRtn = Msj(
            tipo,
            msj,
            `El campo ${campo} puede tener como máximo ${limit} caracteres`
          )
          break
        case 'date.base':
          msjRtn = Msj(tipo, msj, `El campo ${campo} debe completarse`)
          break
        case 'date.min':
          msjRtn = Msj(
            tipo,
            msj,
            `El campo ${campo} debe ser mayor a ${Moment(limit).format('DD.MM.YYYY')}`
          )
          break
        case 'date.max':
          msjRtn = Msj(
            tipo,
            msj,
            `El campo ${campo} debe ser menor a ${Moment(limit).format('DD.MM.YYYY')}`
          )
          break
        case 'any.invalid':
          msjRtn = Msj(tipo, msj, `El campo ${campo} contiene un dato inválido`)
          break
        case 'any.required':
          msjRtn = Msj(tipo, msj, `El campo ${campo} es requerido`)
          break
        case 'number.min':
          msjRtn = Msj(tipo, msj, `El campo ${campo} debe ser mayor a ${limit}`)
          break
        case 'number.max':
          msjRtn = Msj(tipo, msj, `El campo ${campo} debe ser menor a ${limit}`)
          break
        case 'number.base':
          msjRtn = Msj(tipo, msj, `El campo ${campo} debe ser numérico`)
          break
        case 'string.email':
          msjRtn = Msj(tipo, msj, `El campo ${campo} no contiene un email válido`)
          break
        case 'any.allowOnly':
          msjRtn = Msj(tipo, msj, `El valor ingresado en ${campo} no está permitido`)
          break
        case 'array.base':
          msjRtn = Msj(tipo, msj, `El campo ${campo} debe ser una lista válida`)
          break
        case 'array.min':
          msjRtn = Msj(
            tipo,
            msj,
            `Debe seleccionar al menos ${limit} elemento${limit > 1 ? 's' : ''}`
          )
          break
        case 'array.max':
          msjRtn = Msj(
            tipo,
            msj,
            `No puede seleccionar más de ${limit} elemento${limit > 1 ? 's' : ''}`
          )
          break
        default:
          msjRtn = {
            props: {
              children: `Tipo de Error "${tipo}" no especificado en Hook de validación. Revisar esquema: el parámetro Tipos de Errores debe existir en el hook de validación`
            }
          }
      }

      e.message = msjRtn
    })

    return errors
  }

  const Msj = (tipo, textoPropio, textoDefault) => {
    if (textoPropio[tipo]) {
      return textoPropio[tipo]
    } else {
      return { props: { children: textoDefault } }
    }
  }

  const Validador = {
    Kernel: Joi,
    mensaje,
    cargarEsquema,
    validarDato,
    validarForm,
    foco,
    fechaActual
  }

  return { Validador }
}

export default createValidador
